/**
 * ✨ TIER 10 BUILDINGS - Magic & Mysticism
 * 
 * Unlocked by: Arcane Arts, Alchemy, Enchanting, Mysticism
 * Cost multiplier: 3815x | Prod multiplier: 68.7x
 * Costs: 300,000-1,000,000 | Production: 30-70/s
 * Target ROI: ~35 minutes
 */

export const TIER_10_BUILDINGS = {
  wizardTower: {
    id: 'wizardTower',
    name: 'Wizard Tower',
    icon: '🗼',
    tier: 10,
    description: 'Channels mystical energies',
    flavor: 'Where magic takes form.',
    baseCost: { stone: 300000, gems: 50000, knowledge: 125000 },
    baseProduction: { magic: 20.5 },
    unlockCondition: { tech: 'arcane_arts' },
  },

  alchemyLab: {
    id: 'alchemyLab',
    name: 'Alchemy Lab',
    icon: '⚗️',
    tier: 10,
    description: 'Transmutes base materials',
    flavor: 'Turning lead into gold... eventually.',
    baseCost: { stone: 350000, gold: 175000, gems: 40000 },
    baseProduction: { magic: 17.0, gold: 34.5 },
    unlockCondition: { tech: 'alchemy' },
  },

  enchanter: {
    id: 'enchanter',
    name: "Enchanter's Hall",
    icon: '✨',
    tier: 10,
    description: 'Infuses items with magic',
    flavor: 'Weaving spells into steel.',
    baseCost: { gems: 75000, magic: 25000, knowledge: 200000 },
    baseProduction: { magic: 34.5, artifacts: 3.4 },
    unlockCondition: { tech: 'enchanting' },
  },

  sanctum: {
    id: 'sanctum',
    name: 'Sanctum',
    icon: '🔮',
    tier: 10,
    description: 'Sacred place of power',
    flavor: 'Where the veil between worlds grows thin.',
    baseCost: { stone: 500000, gems: 100000, magic: 50000 },
    baseProduction: { magic: 68.5, crystals: 10.0 },
    unlockCondition: { tech: 'mysticism' },
  },
};

export default TIER_10_BUILDINGS;
